//
import PropTypes from "prop-types"

import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups"

import { stateRegions } from "shared/imports/regionConstants"

import {
    LocalExecutiveTypeFilter,
    LegislativeSeniorityFilter,
    LegislativeLeadershipFilter,
    PersonIncomingStatusFilter,
} from "shared/search/containers/Filter/OfficialFilters"

import { OfficialInOutboxTypeFilter } from "shared/search/containers/Filter/OfficialInOutboxFilters"

export const OfficialInOutboxTypeFilterGroup = (props) => genericFilterGroup(props)
OfficialInOutboxTypeFilterGroup.propTypes = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}
OfficialInOutboxTypeFilterGroup.defaultProps = {
    filters: [OfficialInOutboxTypeFilter, LocalExecutiveTypeFilter, PersonIncomingStatusFilter],
    uniqueFilterGroupId: "officialTypeFilterGroup",
    displayLabel: !Userdata.isOnlyEUMode() ? "Official Type" : "Person Type",
    helpText: !Userdata.isOnlyEUMode()
        ? "Filter officials (legislators, executives, local) by role type and status."
        : "Filter for people based on the type of role they have",
}

export const OfficialInOutboxLegislativeRoleFilterGroup = (props) => genericFilterGroup(props)
OfficialInOutboxLegislativeRoleFilterGroup.propTypes = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}
OfficialInOutboxLegislativeRoleFilterGroup.defaultProps = {
    filters: [LegislativeSeniorityFilter, LegislativeLeadershipFilter],
    uniqueFilterGroupId: "officialLegRoleFilterGroup",
    displayLabel: "Legislative Role",
    regions: stateRegions,
    helpText: "Filter legislators by seniority and leadership roles.",
}
